import React from 'react';
import { Search, Filter, Calendar } from 'lucide-react';

export interface FilterOption {
  key: string;
  label: string;
  type: 'select' | 'dateRange' | 'text';
  options?: { value: string; label: string }[];
}

interface FilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filters: Record<string, any>;
  onFilterChange: (key: string, value: any) => void;
  filterOptions: FilterOption[];
}

export const FilterBar: React.FC<FilterBarProps> = ({
  searchTerm,
  onSearchChange,
  filters,
  onFilterChange,
  filterOptions,
}) => {
  return (
    <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm space-y-6">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-12 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-800/10 transition-all"
          />
        </div>
        {filterOptions.map((option) => (
          <div key={option.key} className="flex items-center gap-2 bg-slate-50 border border-slate-100 rounded-2xl px-4 py-2">
            {option.type === 'select' && (
              <>
                <Filter className="text-slate-400 w-4 h-4" />
                <select
                  value={filters[option.key] || 'all'}
                  onChange={(e) => onFilterChange(option.key, e.target.value)}
                  className="bg-transparent focus:outline-none text-sm font-medium text-slate-600 cursor-pointer"
                >
                  <option value="all">{option.label}</option>
                  {option.options?.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </>
            )}
            {option.type === 'dateRange' && (
              <div className="flex items-center gap-2">
                <Calendar className="text-slate-400 w-4 h-4" />
                <input
                  type="date"
                  value={filters[`${option.key}Start`] || ''}
                  onChange={(e) => onFilterChange(`${option.key}Start`, e.target.value)}
                  className="bg-transparent focus:outline-none text-sm font-medium text-slate-600 cursor-pointer"
                />
                <span className="text-slate-300">-</span>
                <input
                  type="date"
                  value={filters[`${option.key}End`] || ''}
                  onChange={(e) => onFilterChange(`${option.key}End`, e.target.value)}
                  className="bg-transparent focus:outline-none text-sm font-medium text-slate-600 cursor-pointer"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
